<div class="row">
    <div *ngIf="WarrantiesList?.length==0;then NoWarranties else Warranties"></div>

    <ng-template #NoWarranties>
        <div class="col-md-12">
            <p> {{ 'NoDataFound' | translate }}</p>
        </div>
    </ng-template>

    <ng-template #Warranties>
        <div class="col-lg-4 col-sm-4 m-b-15" *ngFor="let Warranty of WarrantiesList">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                    <mat-card-title class="mat-mdc-card-title text-white">
                        {{ Warranty.clientName| subString:20 }}
                    </mat-card-title>
                    <div class="d-flex divIcons">
                        <i-tabler name="eye" class="icon-20 d-flex clickIcon"
                            (click)="ViewWarrantyDetails(Warranty.id)"></i-tabler>
                    </div>
                </mat-card-header>
                <mat-card-content class="mat-mdc-card-content text-center" *ngFor="let product of Warranty.costCalcs">
                    <div class="row text-right">
                        <div class="col-md-12">
                            <p>
                                <span class="spanproduct"> {{ 'ProductsGuarantee' | translate}} :</span>
                                <span>{{product.productName|subString:25}}</span>
                            </p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </ng-template>
</div>